import Cloudinary from "../../utils/cloudinaryConfig"

export const cloudinaryFetch = ({ imageFile }: { imageFile: File }) => {
  const formData = new FormData();
  formData.append("file", imageFile);
  formData.append("folder", "UserCreatedRecipes");
  formData.append("upload_preset", "userCreated");
  const response = fetch(
    `https://api.cloudinary.com/v1_1/${Cloudinary.cloud.cloudName}/image/upload`,
    {
      method: "POST",
      body: formData,
    }
  )
  return response
}

export const cloudinaryUploadCookingHistoryFeedback = async ({ imageUrl }: { imageUrl: string }) => {

  const blob = await fetch(imageUrl).then(r => r.blob());
  const formData = new FormData();
  formData.append('file', blob);
  formData.append('upload_preset', 'feedbackImages');
  formData.append('folder', 'feedbackImagesCookingHistory');

  const response = await fetch(`https://api.cloudinary.com/v1_1/${Cloudinary.cloud.cloudName}/image/upload`, {
    method: 'POST',
    body: formData
  });

  const data = await response.json();
  return data;
}

export const cloudinaryuploadedRefferalImage = async ({ imageUrl }: { imageUrl: string }) => {

  const blob = await fetch(imageUrl).then(r => r.blob());
  const formData = new FormData();
  formData.append('file', blob);
  formData.append('upload_preset', 'uploadedRefferalImages');
  formData.append('folder', 'uploadedRefferalImages');


  const response = await fetch(`https://api.cloudinary.com/v1_1/${Cloudinary.cloud.cloudName}/image/upload`, {
    method: 'POST',
    body: formData
  });

  const data = await response.json();
  return data;
}

export const cloudinaryuploadedNoteImage = async ({ imageUrl }: { imageUrl: string }) => {

  const blob = await fetch(imageUrl).then(r => r.blob());
  const formData = new FormData();
  formData.append('file', blob);
  formData.append('upload_preset', 'chefgpt');
  formData.append('folder', 'Image_recognition');


  const response = await fetch(`https://api.cloudinary.com/v1_1/${Cloudinary.cloud.cloudName}/image/upload`, {
    method: 'POST',
    body: formData
  });

  const data = await response.json();
  return data;
}